// Semáforo financiero por clase (Mabel 31-oct-2026): verde = margen ≥ 15 % (rentabilidad saludable),
// amarillo = margen positivo pero < 15 % (necesita atención y seguimiento), rojo = margen ≤ 0 % (la clase genera pérdidas).
// El backend manda `semaforo` con la misma regla; aquí se recalcula por si el dato viene de un caché viejo.
export type Semaforo = 'verde' | 'amarillo' | 'rojo' | null;
export const SEMAFORO_VERDE_PCT = 15;
export const semaforoDe = (margenPct: number | null | undefined, activa = true): Semaforo =>
  !activa ? null : margenPct == null ? 'rojo' : margenPct >= SEMAFORO_VERDE_PCT ? 'verde' : margenPct > 0 ? 'amarillo' : 'rojo';
export const SEMAFORO_TEXTO: Record<Exclude<Semaforo, null>, string> = { verde: 'Rentable', amarillo: 'Necesita atención', rojo: 'En pérdida' };
const DOT: Record<Exclude<Semaforo, null>, string> = { verde: 'bg-emerald-500', amarillo: 'bg-amber-400', rojo: 'bg-red-500' };
export const SEMAFORO_FILA: Record<Exclude<Semaforo, null>, string> = {
  verde: 'border-l-emerald-500', amarillo: 'border-l-amber-400', rojo: 'border-l-red-500',
};
export const pct1 = (n: number | null | undefined) => (n == null ? '—' : `${(Math.round(n * 10) / 10).toString()} %`);

export function SemaforoDot({ s, grande = false }: { s: Semaforo; grande?: boolean }) {
  const cls = grande ? 'h-3.5 w-3.5' : 'h-2.5 w-2.5';
  if (!s) return <span className={`inline-block ${cls} shrink-0 rounded-full border border-line bg-surface-2`} title="Sin actividad este mes" aria-label="sin actividad" />;
  return <span className={`inline-block ${cls} shrink-0 rounded-full ${DOT[s]}`} title={SEMAFORO_TEXTO[s]} aria-label={SEMAFORO_TEXTO[s]} data-semaforo={s} />;
}

export function LeyendaSemaforo({ className = '' }: { className?: string }) {
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-content-3 ${className}`} data-testid="rb-leyenda-semaforo">
      <span className="flex items-center gap-1"><SemaforoDot s="verde" /> Rentable (margen ≥ {SEMAFORO_VERDE_PCT} %)</span>
      <span className="flex items-center gap-1"><SemaforoDot s="amarillo" /> Necesita atención (0–{SEMAFORO_VERDE_PCT} %)</span>
      <span className="flex items-center gap-1"><SemaforoDot s="rojo" /> En pérdida (margen ≤ 0 %)</span>
    </div>
  );
}
